<mat-card>
    <mat-card-content>
        <div class="info-panel">
            <div class="desktop-only block icon" *ngIf="dockingContext?.info?.flightType">
                <mat-icon
                    svgIcon="{{ getFlightTypeIconName(dockingContext?.info?.flightType) }}"></mat-icon>
            </div>
            <div class="field centerline">
                <span class="label">Centerline:</span>
                <span class="value" data-cy="docking-centerline">{{ dockingContext?.info?.centerline }}</span>
            </div>
            <div class="field ac-type">
                <span class="label">Aircraft:</span>
                <span class="value">{{ dockingContext?.info?.acType }}</span>
            </div>
            <div class="field ac-type">
                <span class="label">Reg:</span>
                <span class="value">{{ dockingContext?.info?.regNr }}</span>
            </div>
            <div class="field flight">
                <span class="label">Flight:</span>
                <span class="value">{{ dockingContext?.info?.flight }}</span>
            </div>
            <div class="desktop-only block time">
                <app-time-counter [timeType]="timeType" [timeString]="timeString"></app-time-counter>
            </div>
        </div>
        <div class="mobile-only" *ngIf="timeString && timeType">
            <hr>
            <app-docking-flight-info [timeString]="timeString" [timeType]="timeType"
                                     [flightIconName]="getFlightTypeIconName(dockingContext?.info?.flightType)"></app-docking-flight-info>
        </div>
    </mat-card-content>
</mat-card>
